import { ButtonV2 } from '@moneyforward/ap-frontend-components';

import { useTranslation } from '@/i18n';
import { FC, memo } from 'react';

import classNames from 'classnames';
import styles from './TransactionDetailOptionButtonGroup.module.scss';

export type Props = {
  onAdd: () => void;
  isDisabled: boolean;
};

const cx = classNames.bind(styles);

export const TransactionDetailOptionButtonGroup: FC<Props> = memo(
  ({ onAdd, isDisabled }: Props) => {
    const { t } = useTranslation();

    return (
      <div className={cx(styles['button-group'])}>
        <ButtonV2 onClick={onAdd} isDisabled={isDisabled}>
          {t('add')}
        </ButtonV2>
      </div>
    );
  }
);
TransactionDetailOptionButtonGroup.displayName =
  'TransactionDetailOptionButtonGroup';
